import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { updateDoc, doc } from "firebase/firestore";
import { db, auth } from "../../../config/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";

interface FormData {
  title: string;
  description: string;
  postId: string;
}

export const UpdatePost = (props: FormData) => {
  const { title, description, postId } = props;
  const schema = yup.object().shape({
    title: yup.string().required("Title cannot be empty!"),
    description: yup.string().required("Description cannot be empty!"),
    postId: yup.string().required(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
    defaultValues: {
      title: title,
      postId: postId,
      description: description,
    },
  });

  const navigate = useNavigate();

  const [user, loading, error] = useAuthState(auth);
  const docRef = doc(db, "posts", postId);

  const onUpdatePost = async (data: FormData) => {
    try {
      await updateDoc(docRef, {
        ...data,
        username: user?.displayName,
        userId: user?.uid,
      });
      navigate("/myposts");
    } catch (error) {}
  };

  return (
    <form onSubmit={handleSubmit(onUpdatePost)} className='form w-25 mx-auto'>
      <div className='mb-3 '>
        <label htmlFor='title' className='form-label'>
          Title
        </label>
        <input placeholder='Title..' type='text' id='title' className='form-control' {...register("title")} />
        {errors.title && <p className='alert alert-danger py-1 my-1'>{errors.title?.message}</p>}
      </div>
      <input type='text' hidden {...register("postId")} />
      <div className='mb-3'>
        <label htmlFor='description' className='form-label'>
          Description
        </label>
        <textarea placeholder='Description..' id='description' className='form-control' {...register("description")} />
        {errors.description && <p className='alert alert-danger py-1 my-1'>{errors.description?.message}</p>}
      </div>
      <input type='submit' className='btn btn-success' value='Save changes' />
    </form>
  );
};
